import { render, staticRenderFns } from "./form-information.vue?vue&type=template&id=3f6c5665&scoped=true"
import script from "./form-information.vue?vue&type=script&lang=js"
export * from "./form-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c5665",
  null
  
)

export default component.exports